<template>
  <div class="page_eleApplication">
    <div class="eleTltle">入职登记</div>
    <div class="eleForm" v-loading="isdistinguish" element-loading-text="识别中">
      <van-form @submit="onSubmit">
        <van-field v-model="dtlForm.StrEmpName" label="姓名" required :rules="[{ required: true, message: '请填写姓名' }]" />
        <van-field v-model="dtlForm.StrPhoneNum" @blur="checkPhone(dtlForm.StrPhoneNum)" type="tel" label="手机号" required :rules="[{ required: true, message: '请填写手机号' }]" />
        <input id="upload_file" type="file" style="display: none;" accept='image/*' name="file" @change="fileChange($event)" />
        <van-field v-model="dtlForm.StrIdCard" @blur="checkIdcard" required label="身份证号码" right-icon="photograph" placeholder="支持身份证拍照、图片识别" right-icon-class="photo_o" @click-right-icon="distinguish('#upload_file')" :rules="[{ required: true, message: '请填写身份证号码' }]" />

        <van-field v-model="sex" required @click="showSexSelect = true" label="性别" />
        <van-field v-model="birth" required readonly label="出生年月" />
        <van-field v-model="age" required label="年龄" />

        <van-field v-model="dtlForm.StrNationClass" required label="民族" :rules="[{ required: true, message: '请填写民族' }]" />
        <van-field v-model="dtlForm.StrNativeAddr" required label="户籍地址" placeholder="详细地址（例如**省**市**街**号）" :rules="[{ required: true, message: '请填写户籍地址' }]" />
        <van-field v-model="dtlForm.StrPolitical" @click="showPoliticalSelect = true" readonly label="政治面貌" />
        <input id="upload_file3" type="file" style="display: none;" accept='image/*' name="file" @change="fileChange3($event)" />
        <van-field readonly required label="身份证有效终止时间">
          <van-radio-group slot="input" v-model="isLoong" direction="horizontal">
            <van-radio :name="0">非长期有效</van-radio>
            <van-radio :name="1">长期有效</van-radio>
          </van-radio-group>
        </van-field>
        <van-field v-model="dtlForm.DtIcCareEdate" required v-if="isLoong == 0" right-icon="photograph" right-icon-class="photo_o" @click-right-icon.stop="distinguish('#upload_file3')" placeholder="支持身份证背面拍照、图片识别" @click="selectDtIcCareEdate" readonly label="身份证有效终止时间" :rules="[{ required: true, message: '请选择身份证有效终止时间' }]" />
        <van-field v-model="dtlForm.StrCityzenType" @click="showStrCityzenType = true" readonly label="户粮" />
        <van-field v-model="dtlForm.StrNativePlace" label="籍贯" />
        <van-field v-model="dtlForm.StrAddr" label="现住地址" />
        <van-field v-model="dtlForm.StrEduLv" readonly @click="diplomaSeleter = true" label="教育程度" required :rules="[{ required: true, message: '请选择教育程度' }]" />
        <van-field v-model="dtlForm.InsureJob" label="岗位" required :rules="[{ required: true, message: '请填写岗位' }]" />
        <input id="upload_file2" type="file" style="display: none;" accept='image/*' name="file" @change="fileChange2($event)" />
        <van-field v-model="dtlForm.StrBankCard" placeholder="请准确填写本人银行卡，支持拍照、图片识别" required :rules="[{ required: true, message: '请输入银行卡号或输入暂无' }]" label="银行卡号" right-icon="photograph" right-icon-class="photo_o" @click-right-icon="distinguish('#upload_file2')" />
        <van-field v-model="dtlForm.StrBankName" required :rules="[{ required: true, message: '请输入开户银行或输入暂无' }]" label="开户银行" />

        <van-field v-model="dtlForm.StrContName" label="紧急联系人" required :rules="[{ required: true, message: '请输入紧急联系人' }]" />
        <van-field v-model="dtlForm.StrContTel" @blur="checkPhone(dtlForm.StrContTel)" type="tel" label="紧急联络方式" required :rules="[{ required: true, message: '请输入紧急联络方式' }]" />

        <van-field v-model="dtlForm.PushName" @click="showChannel = true" readonly label="推荐渠道" required :rules="[{ required: true, message: '请选择推荐渠道' }]" />
        <van-field v-model="dtlForm.PushRemark" label="推荐渠道备注" required :rules="[{ required: true, message: '请输入推荐渠道备注' }]" />
        <van-field readonly label="是否住宿">
          <van-radio-group slot="input" v-model="dtlForm.StrIsStay" direction="horizontal">
            <van-radio name="是">是</van-radio>
            <van-radio name="否">否</van-radio>
          </van-radio-group>
        </van-field>

        <!-- <van-field readonly label="是否需要工作服">
          <van-radio-group slot="input" v-model="needWorkClothes" direction="horizontal">
            <van-radio name="是">是</van-radio>
            <van-radio name="否">否</van-radio>
          </van-radio-group>
        </van-field>
        <van-field v-model="dtlForm.ClothingSizes" @click="showClothingSizes = true" readonly label="衣服尺码" :required="needWorkClothes=='是' ? true :false" :rules=" needWorkClothes=='是' ? [{ required: true, message: '请选择衣服尺码' }] : []" />
        <van-field v-model="dtlForm.ShoeSize" label="鞋子尺码" :required="needWorkClothes=='是' ? true :false" :rules=" needWorkClothes=='是' ? [{ required: true, message: '请输入鞋子尺码' }] : []" /> -->

        <van-field v-model="dtlForm.AlmaMater" label="毕业院校" />

        <van-field v-model="dtlForm.StrSignNameUrl" @click="signatureHandle" readonly label="签字" required :rules="[{ required: true, message: '请签字' }]">
          <template #input v-if="dtlForm.StrSignNameUrl">
            <el-image :src="$store.state.EMP.imgPath + dtlForm.StrSignNameUrl" />
          </template>
        </van-field>

        <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="5" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="contractList">
          <el-button size="small" type="primary" style="margin-left: 20px;">上传其他附件</el-button>
        </el-upload>

        <div class="workExp">工作经历</div>
        <div v-for="(item, index) in workExpList" :key="`work_${index}`">
          <div class="topLine" v-if="index>0"></div>
          <van-field v-model="item.StrProName" label="工作单位" />
          <van-field v-model="item.StrJobInf" label="职位/岗位" />
          <van-field v-model="item.StrRemark" label="离职原因" />
          <van-field v-model="item.Strworktimestart" @click="handleDate(index,'Strworktimestart','workExpList','选择开始时间')" readonly label="开始时间" />
          <van-field v-model="item.Strworktimeend" @click="handleDate(index,'Strworktimeend','workExpList','选择结束时间')" readonly label="结束时间" />
        </div>
        <div class="flex">
          <div class="flex aic cp" style="margin-left:30px" @click="addWorkExp">
            <i class="el-icon-circle-plus icon01"></i>
            <el-button type="text" style="margin-left:5px">添加工作经历</el-button>
          </div>

          <div class="flex aic cp" style="margin-left:30px" @click="delListItem('workExpList')" v-if="workExpList.length>1">
            <i class="el-icon-delete icon02"></i>
            <el-button type="text" style="margin-left:5px">删除</el-button>
          </div>
        </div>

        <div class="workExp">家庭成员</div>
        <div v-for="(item, index) in familyList" :key="`family_${index}`">
          <div class="topLine" v-if="index>0"></div>
          <van-field v-model="item.Relationship" label="称谓" />
          <van-field v-model="item.Name" label="姓名" />
          <van-field v-model="item.BirthDate" @click="handleDate(index,'BirthDate','familyList','选择出生日期')" readonly label="出生日期" />
          <van-field v-model="item.Workplace" label="工作单位" />
          <van-field v-model="item.Position" label="职务" />
          <van-field v-model="item.Telephone" label="联系电话" />
        </div>
        <div class="flex">
          <div class="flex aic cp" style="margin-left:30px" @click="addFamily">
            <i class="el-icon-circle-plus icon01"></i>
            <el-button type="text" style="margin-left:5px">添加家庭成员</el-button>
          </div>

          <div class="flex aic cp" style="margin-left:30px" @click="delListItem('familyList')" v-if="familyList.length>1">
            <i class="el-icon-delete icon02"></i>
            <el-button type="text" style="margin-left:5px">删除</el-button>
          </div>
        </div>

        <div class="workExp">教育经历</div>
        <div v-for="(item, index) in eduExpList" :key="`edu_${index}`">
          <div class="topLine" v-if="index>0"></div>
          <van-field v-model="item.EnrollmentDate" @click="handleDate(index,'EnrollmentDate','eduExpList','选择入学时间')" readonly label="入学时间" />
          <van-field v-model="item.GraduationTime" @click="handleDate(index,'GraduationTime','eduExpList','选择毕业时间')" readonly label="毕业时间" />
          <van-field v-model="item.SchoolName" label="学校名称" />
          <van-field v-model="item.Professional" label="专业" />
          <van-field v-model="item.Remark" label="备注" />
        </div>
        <div class="flex">
          <div class="flex aic cp" style="margin-left:30px" @click="addEdu">
            <i class="el-icon-circle-plus icon01"></i>
            <el-button type="text" style="margin-left:5px">添加教育经历</el-button>
          </div>

          <div class="flex aic cp" style="margin-left:30px" @click="delListItem('eduExpList')" v-if="eduExpList.length>1">
            <i class="el-icon-delete icon02"></i>
            <el-button type="text" style="margin-left:5px">删除</el-button>
          </div>
        </div>

        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" :disabled="isSuccess || !dtlForm.jobid">{{ isSuccess ? '已完成' :
            '提交' }}</van-button>
        </div>
      </van-form>
    </div>

    <van-popup v-model="showSexSelect" position="bottom">
      <van-picker title="选择性别" show-toolbar :columns="sexList" @confirm="onConfirmSex" @cancel="showSexSelect = false" />
    </van-popup>

    <van-popup v-model="showPoliticalSelect" position="bottom">
      <van-picker title="选择政治面貌" show-toolbar :columns="politicalList" @confirm="onConfirmPolitical" @cancel="showPoliticalSelect = false" />
    </van-popup>

    <van-popup v-model="showDtIcCareEdate" position="bottom" :close-on-click-overlay="false">
      <van-datetime-picker v-model="DtIcCareEdate" type="date" title="选择身份证有效终止时间" @confirm="confirmDtIcCareEdate" :min-date="minDate" :max-date="maxDate" @cancel="cancelDtIcCareEdate" />
    </van-popup>

    <van-popup v-model="showStrCityzenType" position="bottom">
      <van-picker title="选择户粮" show-toolbar :columns="StrCityzenTypeList" @confirm="onConfirmStrCityzenType" @cancel="showStrCityzenType = false" />
    </van-popup>
    <!--教育程度要求-->
    <van-popup v-model="diplomaSeleter" position="bottom" :style="{ height: '50%' }">
      <van-picker title="选择教育程度" show-toolbar :columns="eduList" @confirm="onConfirmEducation" @cancel="diplomaSeleter = false" />
    </van-popup>

    <van-popup v-model="showChannel" position="bottom">
      <van-picker title="选择推荐渠道" show-toolbar :columns="ChannelList" @confirm="onConfirmChannel" @cancel="showChannel = false" />
    </van-popup>

    <van-popup v-model="showWorkDate" position="bottom">
      <van-datetime-picker v-model="workDate" type="date" :title="title" @confirm="confirmWorkDate" :min-date="minDate" :max-date="maxDate" @cancel="showWorkDate = false" />
    </van-popup>

    <van-popup v-model="showClothingSizes" position="bottom">
      <van-picker title="选择衣服尺码" show-toolbar :columns="sizeList" @confirm="onConfirmClothingSizes" @cancel="showClothingSizes = false" />
    </van-popup>

    <!-- <van-popup v-model="showSignature" position="bottom">
      <div class="signature-container">
        <canvas ref="signaturePad"></canvas>
        <div class="signBot">
          <div class="signBtn" @click="saveSignature">取消</div>
          <div class="signBtn save" @click="saveSignature">保存</div>
        </div>
      </div>
    </van-popup> -->

    <van-dialog v-model="showSignature" title="签字" show-cancel-button @cancel="showSignature = false" @confirm="saveSignature">
      <div class="signature-container">
        <canvas ref="signaturePad"></canvas>
      </div>
    </van-dialog>

  </div>
</template>

<script>
  import xz from "@/common";
  import SignaturePad from 'signature_pad';
  import moment from 'moment';
  export default {
    data() {
      return {
        name: "",
        PhoneNum: "",
        strIdCard: "",
        id: "",
        Bankcard: "",
        DepositBank: "",
        Address: '',
        Education: '',
        isSuccess: false,
        isLoading: false,
        jobid: '',
        projectid: '',
        userid: '',
        docHead: this.$store.state.EMP.docPath,
        dtlForm: {
          StrExcelPath: "",
          IntExcelLine: null,
          GdUserId: "",
          StrSrvCent: "",
          StrBlCmp: "",
          StrObjName: "",
          SubProject: null,
          StrProjectType: "",
          StrObjInstName: "",
          StrUserName: "",
          IntSerialNumber: null,
          StrFileNo: "",
          StrTmpProject: null,
          StrDepName: "",
          StrJobInf: null,
          StrEmpName: "",
          StrIdCard: "",
          StrPolitical: "",
          DtIcCareEdate: null,
          StrCityzenType: "",
          StrPhoneNum: "",
          StrContName: null,
          InsureJob: '',
          StrContTel: null,
          StrNationClass: "",
          StrNativePlace: "",
          StrNativeAddr: "",
          StrAddr: "",
          StrEduLv: "",
          StrInsuranceType: "",
          DtInsuranceDate: "",
          StrMedicalCard: null,
          DtEntryBdate: "",
          StrContractType: "",
          IntContractNum: null,
          StrContractBedate: null,
          DtProbationEdate: null,
          DtContractBtime: "",
          DtContractTime: "",
          StrWorkState: "",
          DtDepartureDate: "",
          DtRealDepartureDate: "",
          StrBankCard: "",
          StrBankName: "",
          StrWithdrawal: "",
          StrInCity: "",
          StrOutsideCity: "",
          StrOther: "",
          StrPetype: "",
          StrPeres: "",
          StrEmpUsrStatus: null,
          DtInjuryBdate: null,
          StrDisabilityLevel: null,
          DtInjuryEdate: null,
          StrBlacklist: null,
          StrBlacklistReason: null,
          StrRemark: null,
          Sctjr: null,
          Gsqd: null,
          Gsqdtjr: null,
          Wbqd: null,
          Wbqdtjr: null,
          Qtqk: "",
          DtInsertDate: "",
          PushTime: "",
          PushRemark: "",
          MarriageState: "",
          IsCheckUp: "",
          OutCompanyReason: "",
          SchoolName: "",
          InSchoolTime: "",
          OutSchoolTime: "",
          ContractInfo: null,
          ThreeBeginTime: "",
          ThreeEndTime: "",
          FrontCardIdUrl: null,
          VersoCardIdUrl: null,
          BankCardUrl: null,
          ContractUrl: null,
          Extend: null,
          Json: "",
          CompanyAge: "",
          OutCompanyOptionTime: null,
          SignJob: null,
          InsureJob: null,
          ContractJson: null,
          OtherUrl: null,
          jobid: '',
          projectid: null,
          userid: '',
          PushName: '',
          StrIsStay: '', //是否住宿
          PushRemark: '',
          StrSignNameUrl: '', //签字URL
          ClothingSizes: '',
          ShoeSize: '',
          AlmaMater: '',
        },
        needWorkClothes: false,
        showChannel: false,
        phoneJudge: false,
        ChannelList: [
          '社招推荐人',
          '公司渠道',
          '供应商',
          '网招',
          '客服部',
          '业务项目部',
          '校招部',
          '招聘部',
          '企业转移',
          '员工内荐',
          '其他情况'
        ],
        sex: '',
        birth: '',
        age: '',
        showSexSelect: false, //选择性别
        sexList: ['男', '女'],
        diplomaSeleter: false, //选择学历
        eduList: ['初中及以下', '高中', '中专', '大专', '本科', '硕士', '博士'],
        showPoliticalSelect: false,
        politicalList: ['党员', '团员', '群众', '其他'],
        showDtIcCareEdate: false,
        DtIcCareEdate: null,
        showStrCityzenType: false,
        StrCityzenTypeList: ['居', '农'],
        idcardJudge: false, //身份证校验
        contractList: [],
        maxDate: new Date(2099, 12, 31),
        minDate: new Date(1900, 1, 1),
        isLoong: 0,
        workExpList: [{
          StrProName: '', //工作单位
          StrJobInf: '', //职位/岗位
          StrRemark: '', //离职原因
          Strworktimestart: '', //开始年月
          Strworktimeend: '', //结束年月
        }],
        eduExpList: [{
          EnrollmentDate: '', //入学时间
          GraduationTime: '', //毕业时间
          SchoolName: '', //学校名称
          Professional: '', //专业
          Remark: '', //备注
        }],
        familyList: [{
          Relationship: '', //称谓
          Name: '', //姓名
          BirthDate: '', //出生日期
          Workplace: '', //工作单位
          Position: '', //职务
          Telephone: '', //联系电话
        }],
        workDate: new Date(2025, 1, 1),
        showWorkDate: false,
        title: '',
        dateType: '',
        listType: '',
        index: 0,
        isdistinguish: false,
        access_token: '', //百度token
        signaturePad: null,
        showSignature: false,
        needWorkClothes: null,
        showClothingSizes: false,
        sizeList: ['L', 'XL', 'XXL', 'XXXL', 'XXXXL'],
      };
    },
    async created() {
      this.$store.commit("setHiddenLeft", true);
      this.getBaiduToken();
      console.log(this.$route);
      if (this.$route.query.jobid != undefined && this.$route.query.jobid) {
        this.jobid = this.$route.query.jobid;
        this.projectid = this.$route.query.projectid;
        this.userid = this.$route.query.userid;
        this.getInfo();
      } else {
        this.$toast({
          duration: 4000,
          type: "fail",
          message: "二维码异常或二维码已过期,请重新获取二维码",
        });
      }
    },
    mounted() {
      // const randomNumber = (min, max) =>
      //   Math.round(Math.random() * (max - min) + min);
      // console.log(randomNumber(51, 100));
    },
    methods: {
      //获取百度token
      getBaiduToken() {
        xz.GetBdToken().then(res => {
          if (res.status == 'ok') {
            this.access_token = res.msg;
          }
        })
      },
      getInfo() {
        let d = {
          jobid: this.jobid,
          projectid: this.projectid,
          userid: this.userid,
        }
        const formData = new FormData();
        formData.append("strjson", JSON.stringify(d));
        xz.H5ProjectInfo(formData).then(res => {
          if (res.status == 'ok') {
            this.dtlForm.jobid = res.data.jobid;
            this.dtlForm.userid = res.data.UserId;
            this.dtlForm.projectid = res.data.Projectid;
          } else {
            this.$toast.fail(res.msg);
          }
        })
      },
      //调用相册&相机识别
      distinguish(name) {
        $(name).click();
      },
      fileChange(el) {
        let file = $("#upload_file").get(0).files[0];
        console.log(file)
        let formData2 = new FormData();
        formData2.append("action", "save");
        formData2.append("pagename", "entimg");
        formData2.append("userid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData2.append("entid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData2.append("entPicFile", file, file.name);
        xz.uploadCert(formData2).then((res) => {
          if (res) {
            this.dtlForm.FrontCardIdUrl = res;
            this.isdistinguish = true;
            let formData = new FormData();
            formData.append("image", res);
            formData.append("id_card_side", 'front');
            xz.PostOcrbd(formData).then((r) => {
              try {
                this.$toast.success('识别成功，请核对');
                this.isdistinguish = false;
                this.dtlForm.StrEmpName = r.msg.words_result.姓名.words;
                this.dtlForm.StrIdCard = r.msg.words_result.公民身份号码.words;
                this.dtlForm.StrNativeAddr = r.msg.words_result.住址.words;
                this.idcardJudge = true;
                this.dtlForm.StrNationClass = r.msg.words_result.民族.words;
                this.getBirth()
              } catch (e) {
                this.isdistinguish = false;
                this.$toast.fail('识别失败！');
              }
            })
          }
        })
      },
      checkPhone(val) {
        const regex = /^1[3-9]\d{9}$/;
        if (!regex.test(val)) {
          this.phoneJudge = false;
          this.$toast.fail('请填写正确的手机号码')
        } else {
          this.phoneJudge = true;
        }
      },
      // 身份证校验
      checkIdcard() {
        let val = this.dtlForm.StrIdCard;
        if (val.length == 0) {
          this.idcardJudge = false;
        } else if (val.length != 18) {
          this.idcardJudge = false;
          this.$toast.fail('身份证格式不正确')
        } else {
          const idcode = val;
          const weight_factor = [
            7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,
          ];
          const check_code = [
            "1",
            "0",
            "X",
            "9",
            "8",
            "7",
            "6",
            "5",
            "4",
            "3",
            "2",
          ];
          const code = idcode + "";
          const last = idcode[17].toUpperCase(); // 最后一个
          const seventeen = code.substring(0, 17);
          // ISO 7064:1983.MOD 11-2
          // 判断最后一位校验码是否正确
          const arr = seventeen.split("");
          const len = arr.length;
          let num = 0;
          for (let i = 0; i < len; i++) {
            num = num + arr[i] * weight_factor[i];
          }
          // 获取余数
          var resisue = num % 11;
          var last_no = check_code[resisue];
          // 格式的正则
          // 正则思路
          var idcard_patter =
            /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
          // 判断格式是否正确
          var format = idcard_patter.test(idcode);
          console.log(last === last_no && format == true)
          if (last === last_no && format == true) {
            this.idcardJudge = true;
            this.getBirth()
          } else {
            this.idcardJudge = false;
            this.$toast.fail('身份证格式不正确')
          }
        }
      },
      //计算生日 年龄 性别
      getBirth() {
        if (this.dtlForm.StrIdCard != undefined && this.dtlForm.StrIdCard) {
          let idCard = this.dtlForm.StrIdCard.replace(/\s/g, '');
          let age;
          let sexnum = null;
          let sex = null;
          let myDate = new Date();
          let month = myDate.getMonth() + 1;
          var day = myDate.getDate();
          sexnum = idCard.substring(16, 17);
          if (sexnum % 2 === 0) {
            sex = "女";
          } else {
            sex = "男";
          }
          age = myDate.getFullYear() - idCard.substring(6, 10) - 1;
          if (
            idCard.substring(10, 12) < month ||
            (idCard.substring(10, 12) == month && idCard.substring(12, 14) <= day)
          )
            age++;
          var birth = idCard.substring(6, 10) + "-" + idCard.substring(10, 12);
          this.age = age;
          this.birth = birth;
          this.sex = sex;
        }
      },
      fileChange2() {
        let file = $("#upload_file2").get(0).files[0];
        let formData2 = new FormData();
        formData2.append("action", "save");
        formData2.append("pagename", "entimg");
        formData2.append("userid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData2.append("entid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData2.append("entPicFile", file, file.name);
        xz.uploadCert(formData2).then((res) => {
          if (res) {
            this.dtlForm.BankCardUrl = res;
            this.isdistinguish = true;
            let url = '/rest/2.0/ocr/v1/bankcard?access_token=' + this.access_token;
            let param = "url=" + this.$store.state.EMP.imgPath + res;
            xz.baiduOCR(url, param).then((r) => {
              try {
                this.$toast.success('识别成功，请核对');
                this.isdistinguish = false;
                this.dtlForm.StrBankName = r.data.result.bank_name;
                this.dtlForm.StrBankCard = r.data.result.bank_card_number;
              } catch (e) {
                this.isdistinguish = false;
                this.$toast.fail('识别失败！');
              }
            })
          }
        })
      },
      fileChange3() {
        let file = $("#upload_file3").get(0).files[0];
        let formData2 = new FormData();
        formData2.append("action", "save");
        formData2.append("pagename", "entimg");
        formData2.append("userid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData2.append("entid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData2.append("entPicFile", file, file.name);
        xz.uploadCert(formData2).then((res) => {
          if (res) {
            this.dtlForm.VersoCardIdUrl = res;
            this.isdistinguish = true;
            let formData = new FormData();
            formData.append("image", res);
            formData.append("id_card_side", 'back');
            xz.PostOcrbd(formData).then((r) => {
              try {
                this.$toast.success('识别成功，请核对');
                this.isdistinguish = false;
                this.dtlForm.DtIcCareEdate = moment(r.msg.words_result.失效日期.words).format('YYYY-MM-DD');
              } catch (e) {
                this.isdistinguish = false;
                this.$toast.fail('识别失败！');
              }
            })
          }
        })
      },
      //选择性别
      onConfirmSex(v) {
        this.sex = v;
        this.showSexSelect = false;
      },
      // 选择文化程度
      onConfirmEducation(v) {
        this.dtlForm.StrEduLv = v;
        this.diplomaSeleter = false;
      },
      //选择政治面貌
      onConfirmPolitical(v) {
        this.dtlForm.StrPolitical = v;
        this.showPoliticalSelect = false;
      },
      //选择衣服尺码
      onConfirmClothingSizes(v) {
        this.dtlForm.ClothingSizes = v;
        this.showClothingSizes = false;
      },
      onConfirmStrCityzenType(v) {
        this.dtlForm.StrCityzenType = v;
        this.showStrCityzenType = false;
      },
      onConfirmChannel(v) {
        this.dtlForm.PushName = v;
        this.showChannel = false;
      },
      confirmDtIcCareEdate(v) {
        this.dtlForm.DtIcCareEdate = moment(v).format('YYYY-MM-DD');
        this.DtIcCareEdate = moment(v).format('YYYY-MM-DD');
        this.showDtIcCareEdate = false;
      },
      // 上传附件
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData.append("entid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            let d = {
              uid: '',
              url: this.docHead + res,
              name: file.name
            }
            this.contractList.push(d)
            // this.fileList = this.itemInfo.fileUrl
          } else {
            // this.dtlForm.OtherUrl = ''
          }
        });
      },
      // 删除附件
      handleFileRemove(file) {
        this.contractList.forEach((e, i) => {
          if (file.uid == e.uid) {
            this.contractList.splice(i, 1)
          }
        });
        console.log(this.contractList);
      },
      handleExceed() {
        this.$toast.fail(`当前限制最多上传 5 个文件`);
      },
      handleDate(index, dateType, list, title) {
        this.workDate = new Date(2025, 1, 1);
        this.index = index;
        this.dateType = dateType;
        this.title = title;
        this.listType = list;
        this.showWorkDate = true;
      },
      confirmWorkDate(v) {
        this[this.listType][this.index][this.dateType] = moment(v).format('YYYY-MM-DD');
        this.showWorkDate = false;
      },
      addWorkExp() {
        let d = {
          StrProName: '', //工作单位
          StrJobInf: '', //职位/岗位
          StrRemark: '', //离职原因
          Strworktimestart: '', //开始年月
          Strworktimeend: '', //结束年月
        }
        this.workExpList.push(d)
      },
      addFamily() {
        let d = {
          Relationship: '', //称谓
          Name: '', //姓名
          BirthDate: '', //出生日期
          Workplace: '', //工作单位
          Position: '', //职务
          Telephone: '', //联系电话
        }
        this.familyList.push(d)
      },
      addEdu() {
        let d = {
          EnrollmentDate: '', //入学时间
          GraduationTime: '', //毕业时间
          SchoolName: '', //学校名称
          Professional: '', //专业
          Remark: '', //备注
        }
        this.eduExpList.push(d)
      },
      delListItem(list) {
        this[list].splice(this.workExpList.length - 1, 1)
      },
      onSubmit() {
        if (this.dtlForm.StrPhoneNum.length != 11) {
          this.$toast.fail('请输入正确的手机号');
        } else if (this.idcardJudge && this.phoneJudge) {
          if (!this.isLoading) {
            this.isLoading = true;
            if (this.contractList.length > 0) {
              let d = JSON.parse(JSON.stringify(this.contractList))
              this.dtlForm.OtherUrl = JSON.stringify(d)
            }
            if (this.isLoong == 1) {
              this.dtlForm.DtIcCareEdate = '2999-12-31'
            }
            if (this.dtlForm.StrIdCard && this.dtlForm.StrIdCard.includes('x')) {
              this.dtlForm.StrIdCard = val = val.replace(/x/g, 'X');
            }
            const formData = new FormData();
            formData.append("strjson", JSON.stringify(this.dtlForm));
            formData.append("strwork", JSON.stringify(this.workExpList));
            formData.append("stredu", JSON.stringify(this.eduExpList));
            formData.append("strmember", JSON.stringify(this.familyList));
            console.log(formData)
            xz.H5ProjectOption(formData, 'H5ProjectOptionnew').then((res) => {
              if (res.status == "ok") {
                this.$toast({
                  duration: 5000,
                  type: "success",
                  message: "保存成功"
                });
                this.isSuccess = true;
                setTimeout(() => {
                  this.close()
                }, 1000);
              } else {
                setTimeout(() => {
                  this.isLoading = false;
                }, 2000);
                this.$toast.fail(res.msg);
              }
            });
          }
        } else {
          if (!this.idcardJudge) {
            this.$toast.fail('请输入正确的身份证');
          }
          if (!this.phoneJudge) {
            this.$toast.fail('请输入正确的手机号');
          }
        }
      },
      selectDtIcCareEdate() {
        if (!this.dtlForm.DtIcCareEdate) {
          this.DtIcCareEdate = new Date('2025-01-01');
        }
        this.dtlForm.DtIcCareEdate = new Date('2025-01-01');
        this.showDtIcCareEdate = true;
      },
      close() {
        if (typeof WeixinJSBridge !== 'undefined') {
          WeixinJSBridge.call('closeWindow');
        } else {
          window.open("about:blank", "_self")
          window.close();
        }
      },
      signatureHandle() {
        this.showSignature = true;
        setTimeout(() => {
          this.initSignaturePad();
        }, 500);
      },
      initSignaturePad() {
        const canvas = this.$refs.signaturePad;
        this.signaturePad = new SignaturePad(canvas, {
          backgroundColor: 'rgba(255, 255, 255, 0)'
        }); // 设置背景透明，以便可以看到下面的内容（如果有的话）
        const dpr = window.devicePixelRatio || 1;
        const rect = canvas.getBoundingClientRect();
        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;
        canvas.style.width = `${rect.width}px`;
        canvas.style.height = `${rect.height}px`;
        const baseWidth = 2;
        const ctx = canvas.getContext("2d");
        ctx.scale(dpr, dpr);
      },
      clearSignature() {
        this.signaturePad.clear(); // 清空签名板
      },
      saveSignature() {
        const data = this.signaturePad.toDataURL(); // 获取签名的数据URL，可以用于保存或显示签名图像
        let byteString = atob(data.split(',')[1]);
        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        let file = new Blob([ab], {
          type: 'image/png'
        });
        let fileName = new Date().valueOf().toString() + Math.random().toString(36).substring(2) + '签字.png';
        const formData = new FormData();
        formData.append("pagename", "entimg");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData.append("entid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData.append("excel", file, fileName);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.dtlForm.StrSignNameUrl = res;
          } else {
            this.dtlForm.StrSignNameUrl = '';
          }
        });
      },
      cancelDtIcCareEdate() {
        this.dtlForm.DtIcCareEdate = '';
        this.showDtIcCareEdate = false;
      }
    },
  };
</script>
<style scoped>
  .page_eleApplication {
    background: #fff;
    min-height: 100vh;
  }

  .eleTltle {
    font-weight: 600;
    font-size: 17px;
    text-transform: capitalize;
    width: 100%;
    height: 56px;
    line-height: 56px;
    background: #fff;
    text-align: center;
  }

  .eleForm {
    /* background: #fff; */
    padding: 20px 0;
  }

  .workExp {
    font-weight: 600;
    font-size: 16px;
    padding-left: 5px;
    margin: 10px 5px;
    padding-top: 10px;
    border-top: 1px solid #ccc;
  }

  .topLine {
    border-top: 1px solid #ccc;
    margin-bottom: 10px;
  }

  .icon01 {
    color: #19bd92;
    font-size: 20px;
    cursor: pointer;
  }

  .icon02 {
    color: #F56C6C;
    font-size: 20px;
    cursor: pointer;
  }

  .signature-container {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
  }

  .signature-container canvas {
    width: 100%;
    height: auto;
    /* 或固定高度，如 300px */
    max-width: 100%;
    display: block;
    border: 1px solid #ccc;
    background-color: #fff;
  }
</style>
<style>
  .page_eleApplication .van-field__control::placeholder {
    color: #ee0a24;
  }

  .page_eleApplication .van-icon-photograph:before {
    font-size: 26px;
  }

  .page_eleApplication .el-loading-spinner {
    top: 50vh;
  }
</style>